import { FileUploadModel } from "./file/file-upload-model";

export class BaseModel {
    id?: string;
    modifiedById?: string;
    modifiedDate?: Date;
    createdById?: string;
    createdDate?: Date;
        
    /**
     * Used to save profile and cover photos as well as any staged 
     * files along with the entity in attached document mode.
     */
    fileUpload: FileUploadModel = new FileUploadModel();
}
